export default __webpack_public_path__ + "static/media/5.0b69206e.png";